// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var EmailRead = function EmailRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 5h12c.275 0 .5.225.5.5v.69l-.706.579A5.5 5.5 0 0 1 16 6.522V5.5c0-1.103-.897-2-2-2H2c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h9.256a5.5 5.5 0 0 1-.881-1.5H2a.5.5 0 0 1-.5-.5V8.131l4.438 3.644a3.25 3.25 0 0 0 4.065.047 5.4 5.4 0 0 1 .7-2.513l-1.59 1.307a1.75 1.75 0 0 1-2.222 0L1.5 6.19V5.5c0-.275.225-.5.5-.5m18 7a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-2.397-1.353a.5.5 0 0 1 0 .706l-2.25 2.25a.5.5 0 0 1-.706 0l-1.25-1.25a.5.5 0 0 1 0-.706.5.5 0 0 1 .706 0l.897.897 1.897-1.897a.5.5 0 0 1 .706 0"
  }));
};
